import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { ScrollText } from 'lucide-react';
import { LegislationItems } from './LegislationItems';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/obligations')({
    staticData: {
        metadata: {
            title: 'Obligations',
        },
        ui: {
            icon: ScrollText,
            title: 'Obligations',
            subtitle: 'Manage legislation items',
            menuDescription: 'Manage legislation items',
        },
        modules: ['compliance'],
        permissions: ['settings:update'],
    },
    component: Obligations,
});

function Obligations() {
    return (
        <PageController route={Route}>
            <LegislationItems />
        </PageController>
    );
}
